<!--
 * @LastEditTime: 2023-01-06 17:54:40
 * @Description: 选择激活账号方式
-->
<template>
	<div class="way_back">
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<div class="common_list_self">
			<div class="c_l_s_item" v-for="item in list" :key="item.value" @click="handleJump(item.value)">
				<div class="c_l_s_left">
					<img class="c_l_s_l_img" :src="item.src" />
					<span>{{ item.name }}</span>
				</div>
				<Icon class="c_l_s_right" name="arrow" />
			</div>
		</div>
	</div>
</template>

<script>
import { NavBar, Icon } from "vant";
import { commonAPI } from "@/apis";

import i_phone from "@/assets/mAssets/images/forget/phone.png";
import i_email from "@/assets/mAssets/images/forget/email.png";

export default {
	name: "WayBack",
	components: { NavBar, Icon },
	data() {
		return {
			basicSetInfo: {}, //基础配置
			defaultList: [
				{ value: "1", name: this.$t("webapp.activate.type_email"), src: i_email },
				{ value: "2", name: this.$t("webapp.activate.type_mobile"), src: i_phone },
			],
			list: [],
		};
	},
	created() {
		//基础配置信息
		this.basicSetInfo = JSON.parse(sessionStorage.getItem("BASIC_SET_INFO"));
		console.log(this.basicSetInfo);
		this.defaultList.forEach((el) => {
			let flag = this.basicSetInfo.jhfs.includes(el.value);
			if (flag) {
				this.list.push(el);
			}
		});
	},
	methods: {
		// 跳转
		handleJump(value) {
			this.$router.push({
				path: "/mactivate/verifyInfo",
				query: { id: value },
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
</style>
